import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import apiClient from "../../../../application/apis/tenant-management/tenant-management-client";

export const useCheckGroupExistence = (
  groupName: string,
  bounceTime = 800,
): [string, boolean] => {
  const [checkedGroupName, setCheckedGroupName] = useState<string>(groupName);
  const [isExistGroup, setIsExistGroup] = useState<boolean>(false);

  const existsGroup = useDebouncedCallback(async () => {
    if (groupName === checkedGroupName) {
      return;
    }
    if (groupName === "") {
      setCheckedGroupName(groupName);
      setIsExistGroup(false);
    }
    const { data } = await apiClient.fetchGroups(1, 1, {
      name: groupName,
      nameMatchMode: "exact",
    });
    setCheckedGroupName(groupName);
    setIsExistGroup(data.length > 0);
  }, bounceTime);

  useEffect(() => {
    (async () => {
      await existsGroup();
    })();
  });

  return [checkedGroupName, isExistGroup];
};
